import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AngularPaths, Module } from '@models/index.model';
import { ModulesService } from '@services/index.service';
import { Observable } from 'rxjs';

export class ModuleGuard {
  static forModules(...modules: Module[]) {
    @Injectable({providedIn: 'root'})
    class ModuleCheck  {
      constructor(private _modules: ModulesService, private _router: Router) {}

      public canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
      ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (!this._modules.hasAllModules(...modules)) {
          // This forces to trigger the DefaultRouteGuard which will redirect the user to the default application route.
          return this._router.parseUrl(AngularPaths.DEFAULT);
        }
        return true;
      }
    }
    return ModuleCheck;
  }
}
